// Facebook.js

import React from 'react';
import './Facebook.css'; // Assurez-vous que ce fichier CSS existe au même niveau

const facebookPosts = [
  {
    id: 1,
    src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02sxaDqgVxMQxaH9eT2zqDKsZA23rNx66QtHaSNwfLcSdrjfRahbjkMTx9aBPQ3F9Fl%26id%3D100093118543312&show_text=true&width=500",
    height: "771",
    title: "Publication Facebook Studio Ambre 1"
  },
  {
    id: 2,
    src: "https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fphoto.php%3Ffbid%3D1137700618393491%26set%3Da.544567987706760%26type%3D3&show_text=true&width=500",
    height: "729",
    title: "Publication Facebook Studio Ambre 2"
  },

];

// MODIFICATION: Nom du composant changé de FacebookFeed à Facebook
function Facebook() {
  return (
    <section id="facebook-feed" className="facebook-feed-section">
      <div className="container">
        <h2 className="section-title">Notre Actualité sur Facebook</h2>
        
        <div className="facebook-posts-grid">
          {facebookPosts.map(post => (
            <div key={post.id} className="facebook-post-item">
              <iframe
                src={post.src}
                height={post.height}
                style={{ border: 'none', overflow: 'hidden' }}
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                title={post.title}
                loading="lazy"
              ></iframe>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// MODIFICATION: Exportation mise à jour
export default Facebook;